import React, {useEffect, useState} from "react";
import {Button, Col, Modal, Row, Spinner} from "react-bootstrap";
import {Form as FormikForm, FormField, SubmitButton} from "../../../../components/forms"
import * as yup from 'yup';
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from 'react-bootstrap-table2-editor';
import moment from "moment";
import {uid} from "uid";

// for pdf
import {Document, Font, Image, Page, StyleSheet, Text, usePDF, View} from '@react-pdf/renderer';
import {DataTableCell, Table, TableBody, TableCell, TableHeader} from "@david.kucsai/react-pdf-table";
import RobotoRegular from "../../../../assets/fonts/Roboto-Regular.ttf"
import RobotoBold from "../../../../assets/fonts/Roboto-Bold.ttf"
import RobotoItalic from "../../../../assets/fonts/Roboto-Italic.ttf"
import RobotoBoldItalic from "../../../../assets/fonts/Roboto-BoldItalic.ttf"
import Logo from "../../../../assets/img/MRC Nordomatic logo new 2024.png";
import {User} from "react-feather";

const schema = yup.object().shape({
    reference: yup.string().required("Referentie is niet ingevuld"),
    customer_name: yup.string().required("Klantnaam is niet ingevuld"),
    adress: yup.string().required("Adres is niet ingevuld"),
    zipcode: yup.string().matches(/^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i, "Voer een geldige postcode in").required("postcode is niet ingevuld"),
    city: yup.string().required("Stad naam is niet ingevuld"),
    contact: yup.string().required("Contactpersoon is niet ingevuld")
});

function ProductOrdersPakbonModal() {
    const [show, setShow] = useState(false);
    const [data, setData] = useState([{
        product_order_detail_id: uid(),
        product_name: "",
        product_order_detail_amount: 1,
        product_description: ""

    }])
    const [printReady, setPrintReady] = useState(false)
    const [stateValues, setValues] = useState({
        reference: '',
        customer_name: '',
        adress: '',
        zipcode: '',
        city: '',
        contact: '',
    })
    const [instance, updateInstance] = usePDF({document: <MyDoc values={stateValues} data={data}/>});
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [columns] = useState(
        [
            {
                dataField: "product_order_detail_id",
                hidden: true
            },
            {
                dataField: "product_name",
                text: "Product",
                formatter: (c, r) => {
                    if (c === "DIV") return r.product_order_detail_comment
                    return c
                }
            },
            {
                dataField: "product_description",
                text: "Omschrijving",
            },
            {
                dataField: "product_order_detail_amount",
                text: "Aantal",
            },
        ]
    )

    const handleSubmit = (values) => {
        setValues(values)
    }

    useEffect(() => {
        if (stateValues.customer_name) {
            updateInstance()
            setPrintReady(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [stateValues])

    const cellEdit = () => cellEditFactory({
        mode: 'click',
    })
    const addToTable = () => {
        setData([...data, {
            product_order_detail_id: uid(),
            product_name: "",
            product_order_detail_amount: null,
            product_description: ""
        }])
    }


    return (
        <>
            <Button onClick={handleShow} className={"p-2 m-1"} variant={"warning"} style={{height: 90, width: 90}}>
                <User size={50}/>
                <div>Pakbon</div>
            </Button>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Pakbon maken
                    </Modal.Title>
                </Modal.Header>
                <FormikForm
                    initialValues={stateValues}
                    // Hier is het validatieschema van alle velden
                    validationSchema={schema}
                    onSubmit={handleSubmit}
                >
                    <Modal.Body>
                        <Col className={"m-4"}>
                            <Row>
                                Referentie
                                <hr/>
                            </Row>

                            <Row>
                                <Col>
                                    <FormField name={"reference"}
                                               label={"Referentie"}
                                               className={"mb-3"}
                                               control={"input"}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                VERZEND DETAILS
                                <hr/>
                            </Row>
                            <Row>
                                <Col>
                                    <FormField name={"customer_name"}
                                               label={"Klantnaam"}
                                               className={"mb-3"}
                                               control={"input"}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <FormField name={"adress"}
                                               label={"Adres"}
                                               className={"mb-3"}
                                               control={"input"}
                                    />
                                </Col>
                            </Row>

                            <Row>
                                <Col>
                                    <FormField name={"zipcode"}
                                               label={"Postcode"}
                                               className={"mb-3"}
                                               control={"input"}
                                    />
                                </Col>
                                <Col>
                                    <FormField name={"city"}
                                               label={"Stad"}
                                               className={"mb-3"}
                                               control={"input"}
                                    />

                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <FormField name={"contact"}
                                               label={"Contactpersoon"}
                                               className={"mb-3"}
                                               control={"input"}
                                    />
                                </Col>
                            </Row>
                        </Col>
                        <Row className={"mb-1"}><Col lg={11}></Col><Col><Button onClick={addToTable}
                                                                                className={"float-end"}>+</Button></Col></Row>
                        <BootstrapTable
                            cellEdit={cellEdit()}
                            columns={columns}
                            keyField={"product_order_detail_id"}
                            data={data}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Annuleren
                        </Button>
                        {!printReady ? <SubmitButton title={"Opslaan"} variant="primary"/> :
                            instance.loading ? <Button><Spinner animation="border" variant="light" size="sm"/></Button>
                                : <a href={instance.url} download={`${stateValues.reference} PAKBON.pdf`}>
                                    <Button onClick={() => setPrintReady(false)} variant={"success"}>Download</Button>
                                </a>
                        }
                    </Modal.Footer>
                </FormikForm>
            </Modal>
        </>
    );
}

export default ProductOrdersPakbonModal;


const MyDoc = ({values, data}) => {
    return (<Document>
            <Page style={styles.body}>
                <View style={{flexDirection: "row", justifyContent: "space-between"}}>
                    <Image style={styles.yconLogo} src={Logo}/>
                </View>
                <View style={{flexDirection: "row", justifyContent: "space-between", marginBottom: 20, marginTop: -25}}>
                    <View style={{marginLeft: 20}}>
                        <Text style={styles.title}>AFLEVERADRES</Text>
                        <View style={{flexDirection: "row"}}>
                            <View style={{marginRight: 15}}>
                                <Text style={styles.textSmallAdres}>ADRES</Text>
                                <Text style={styles.textSmall}>CONTACT</Text>
                                <Text style={styles.textSmall}>DATUM</Text>
                                {values.comment ? <Text style={styles.textSmall}>OPMERKING</Text> : null}
                            </View>
                            <View style={{marginRight: 15}}>
                                <Text style={styles.textSmallAdres}>:</Text>
                                <Text style={styles.textSmall}>:</Text>
                                <Text style={styles.textSmall}>:</Text>
                                {values.comment ? <Text style={styles.textSmall}>:</Text> : null}
                            </View>
                            {values.customer_name ? <View>
                                <Text style={styles.textSmall}>{values?.customer_name}</Text>
                                <Text style={styles.textSmall}>{values?.adress}</Text>
                                <Text style={styles.textSmall}>{`${values?.zipcode} ${values?.city}`}</Text>
                                <Text style={styles.textSmall}>{values?.contact}</Text>
                                <Text style={styles.textSmall}>{moment().format("DD-MM-YYYY")}</Text>
                                {values.comment ? <Text style={styles.textSmall}>{values.comment}</Text> : null}
                            </View> : null}
                        </View>
                    </View>
                    <View style={{width: 200}}>
                        <Text style={styles.textSmallRightBold}>MRC innovatief klimaatbeheer B.V.</Text>
                        <Text style={styles.textSmallRight}>Rondweg 30</Text>
                        <Text style={styles.textSmallRight}>8091XB Wezep, Nederland</Text>
                        <Text style={styles.textSmallRight}>BTW nr: NL861399936B01</Text>
                        <Text style={styles.textSmallRight}>KVK nr: 78444411</Text>
                        <Text style={styles.textSmallRight}>IBAN: NL57INGB0006281781</Text>
                        <Text style={styles.textSmallRight}>BIC: INGBNL2A</Text>
                        <Text style={styles.textSmallRight}>(+31) 038 376 01 95</Text>
                        <Text style={styles.textSmallRight}>sm-nl-admin.wezep@nordomatic.com</Text>
                    </View>
                </View>
                <View style={{
                    borderTop: "1px solid black",
                    borderBottom: "1px solid black",
                    paddingVertical: 2,
                    alignContent: "center",
                    justifyContent: "center",
                    marginBottom: 20
                }}>
                    <Text style={styles.pageTitle}> PAKBON
                        - {values.reference} </Text>
                </View>
                <View>
                    <Table style={styles.tableStyle}
                           data={data}>
                        <TableHeader style={styles.tableStyle} includeTopBorder={false} includeRightBorder={false}
                                     includeLeftBorder={false}>
                            <TableCell style={styles.tableStyleHeader} weighting={0.3}>
                                PRODUCT
                            </TableCell>
                            <TableCell style={styles.tableStyleHeader} weighting={0.6}>
                                BESCHRIJVING
                            </TableCell>
                            <TableCell style={styles.tableStyleHeader} weighting={0.1}>
                                QTY
                            </TableCell>
                        </TableHeader>
                        <TableBody includeTopBorder={false} includeRightBorder={false} includeLeftBorder={false}
                                   includeBottomBorder={false}>
                            <DataTableCell style={styles.tableStyleCell}
                                           weighting={0.3}
                                           getContent={(r) => r.product_name === "DIV" ? r.product_order_detail_comment : r.product_name}
                            />
                            <DataTableCell style={styles.tableStyleCell}
                                           weighting={0.6}
                                           getContent={(r) => r.product_description}
                            />
                            <DataTableCell style={styles.tableStyleCell}
                                           weighting={0.1}
                                           getContent={(r) => r.product_order_detail_amount}
                            />
                        </TableBody>
                    </Table>
                </View>
            </Page>
        </Document>
    )
};

Font.register({
    family: 'Roboto', fonts: [
        {src: RobotoRegular}, // font-style: normal, font-weight: normal
        {src: RobotoItalic, fontStyle: 'italic'},
        {src: RobotoBoldItalic, fontStyle: 'italic-bold'},
        {src: RobotoBold, fontStyle: 'bold'},
    ]
});

Font.registerHyphenationCallback(word => [word]);

const styles = StyleSheet.create(
    {
        body: {
            paddingTop: 35,
            paddingBottom: 65,
            paddingHorizontal: 40,
            fontSize: 10
        },
        pageTitle: {
            fontFamily: "Roboto",
            fontStyle: "bold",
            fontSize: 16,
            textAlign: "center",
        },
        title: {
            fontFamily: "Roboto",
            fontStyle: "bold",
            fontSize: 12,
            marginBottom: 5,
        },
        titleRight: {
            fontFamily: "Roboto",
            fontStyle: "bold",
            fontSize: 12,
            textAlign: "right",
            marginBottom: 5
        },
        subTitle: {
            fontFamily: "Roboto",
            fontStyle: "bold",
            fontSize: 11,
            textAlign: "right",
        },
        textSmall: {
            fontFamily: "Roboto",
            fontSize: 9,
            lineHeight: 1.3,
        },
        textSmallRight: {
            fontFamily: "Roboto",
            fontSize: 9,
            textAlign: "right",
            lineHeight: 1.3,
        },
        textSmallRightBold: {
            fontFamily: "Roboto",
            fontStyle: "bold",
            fontSize: 9,
            textAlign: "right",
            lineHeight: 1.3,
        },
        textSmallAdres: {
            fontFamily: "Roboto",
            fontSize: 9,
            textAlign: "right",
            lineHeight: 3.9,
        },
        tableStyle: {
            fontSize: 9,
            justifyContent: "start",
            marginBottom: 20,
        },
        tableStyleCell: {
            fontSize: 9,
            justifyContent: "start",
            padding: 5,
            borderRightColor: "#ffffff",
            borderBottom: "1 solid #cccccc"
        },
        tableStyleHeader: {
            fontSize: 9,
            justifyContent: "start",
            padding: 5,
            borderRightColor: "#ffffff"
        },
        yconLogo: {top: 0, width: "auto", height: 50, marginBottom: 50}

    }
)